import { useEffect } from "react";
import { api } from "@/lib/api";
import { getToken } from "@/lib/auth-token";
import { useAuthStore } from "@/stores/auth-store";

/** Hydrate the auth store from /auth/me on app boot. */
export function useHydrateMe() {
  const { setMe, setLoading } = useAuthStore();

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setMe(res.data))
      .catch(() => setMe(null))
      .finally(() => setLoading(false));
  }, [setMe, setLoading]);
}
